export default __webpack_public_path__ + "static/media/bird.dbe3d3dc.png";